import React from 'react';
import { dummyClick } from './../utilities';

const ViolationCategory = ({ last, index, onSelect, category: { id, title, description } }) => (
  <li className={'p2 ' + (last ? '' : 'border-bottom border-gray-2')}>
    <input id={'category_' + index} type='radio' name='report_categories' data-id={id} onClick={onSelect} />
    <label htmlFor={'category_' + index}>{title}</label>
    <p className='ml3 mb0 pl1 gray-2'>{`(${description})`}</p>
  </li>
);

ViolationCategory.defaultProps = {
  last: false,
  index: 0,
  onSelect: dummyClick,
  category: {
    id: 0,
    title: 'Bad content',
    description: 'This bad content category description'
  }
};

export default ViolationCategory;
